export const LOCAL_STORAGE_AUTHENTICATION_REDIRECT = 'authentication:redirect'
